module.exports = __webpack_public_path__ + "static/2-99912275518cd64465bb5d3e5d444a83.jpg";